export const isObjectEmpty = (obj: any): boolean => {
  if (!obj || typeof obj !== 'object') {
    return true;
  }

  return Object.values(obj).every(value => {
    if (value === null || value === undefined || value === '' || value === false) {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      return isObjectEmpty(value); // Recursively check nested objects
    }

    return false;
  });
};
